
(function () {
  function loadGalleryVideos(scope) {
    (scope || document).querySelectorAll('media-gallery .product-media-container.media-type-video deferred-media:not([loaded])').forEach(function (el) {
      var template = el.querySelector('template');
      if (!template) return;

      var clone = template.content.cloneNode(true);
      el.appendChild(clone);
      el.setAttribute('loaded', '');

      el.querySelectorAll('video').forEach(function (video) {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        video.loop = true;
        video.controls = false;
        video.autoplay = true;
        video.preload = 'metadata';

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { loadGalleryVideos(document); });
  } else {
    loadGalleryVideos(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    loadGalleryVideos(event.target);
  });
})();
